module.exports = {"domain":"pdview.au.auth0.com","clientID":"oigY6wb8ZKzH0s7PMbMC4GCsuvHH5ZJG","audience":"https://pdview.au.auth0.com/userinfo","responseType":"token id_token","scope":"openid profile email","prompt":"none"}


//////////////////
// WEBPACK FOOTER
// ./src/config/auth0.json
// module id = 391
// module chunks = 0